import React, { FC } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ResponseReportWorkStyle } from '../../../../states/types/analyze'
import { LangValue } from '../../../../states/types/common'
import { format } from '../../../../utils/date'
import { setPath } from '../../../../utils/url'
import CATEGORY from '../../../constants/category'
import BarChart from '../BarChart'
import CsvModule from '../CsvModule'
import StackedBarChart from '../StackedBarChart'
import TableList from '../TableList'
import { URL } from '../../../constants/url'

interface Props {
  date: string
  list: ResponseReportWorkStyle
}

const WorkStyle: FC<Props> = (props) => {
  const {
    date,
    list,
  } = props

  const { language } = useParams<{ language: LangValue }>()

  const REMOTE_COLOR = "#FA942B"
  const OFFICE_COLOR = "#FABE80"

  return (
    <>
      {
        Number(format(date, "YYYYMM")) >= 202205 ? (
          <>
            {
              list.office_ip_address_is_exists ? (
                <>
                  {
                    list.comparison.office.active_time || list.comparison.remote.active_time ? (
                      <>
                        <section className="page_contents content-area">
                          <div className="content-block">
                            <div className="block-detail">
                              <div className="grid_area">
                                <div
                                  className="grid_block block_3 reverse"
                                  style={{
                                    backgroundColor: REMOTE_COLOR,
                                  }}
                                >
                                  <div className="title">
                                    リモート活用人数
                                  </div>
                                  <div className="value">
                                    <strong>
                                      {list.summary.remote_member_count}
                                    </strong>
                                    {`/${list.summary.base_member_count}人`}
                                  </div>
                                </div>
                                <div className="grid_block block_3">
                                  <div className="title">
                                    リモート活用割合
                                  </div>
                                  <div className="value">
                                    <strong
                                      style={{
                                        color: REMOTE_COLOR,
                                      }}
                                    >
                                      {list.summary.remote_percentage}
                                    </strong>
                                    %
                                  </div>
                                </div>
                                <div className="grid_block block_6">
                                  <div className="title">
                                    リモート:オフィス比率
                                  </div>
                                  <div className="value ratio">
                                    <strong
                                      style={{
                                        color: REMOTE_COLOR,
                                      }}
                                    >
                                      {Math.round(list.summary.remote_percentage)}
                                    </strong>
                                    :
                                    <strong
                                      style={{
                                        color: REMOTE_COLOR,
                                      }}
                                    >
                                      {100 - Math.round(list.summary.remote_percentage)}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                              <div className="grid_area">
                                <div className="grid_block block_6">
                                  <div className="title">
                                    期間別リモート活用割合
                                  </div>
                                  <StackedBarChart
                                    labels={
                                      [
                                        {
                                          name: "リモート",
                                          color: REMOTE_COLOR,
                                        },
                                        {
                                          name: "オフィス",
                                          color: OFFICE_COLOR,
                                        },
                                      ]
                                    }
                                    list={
                                      list.summary.work_time.map((value) => (
                                        {
                                          title: value.label,
                                          values: [
                                            {
                                              name: "リモート",
                                              value: (value.remote_work_time + value.office_work_time)
                                                ? value.remote_work_time / (value.remote_work_time + value.office_work_time)
                                                : 0,
                                              color: REMOTE_COLOR,
                                            },
                                            {
                                              name: "オフィス",
                                              value: (value.remote_work_time + value.office_work_time)
                                                ? value.office_work_time / (value.remote_work_time + value.office_work_time)
                                                : 0,
                                              color: OFFICE_COLOR,
                                            },
                                          ],
                                        }
                                      ))
                                    }
                                    chartSize={150}
                                    type="percent"
                                  />
                                </div>
                                <div className="grid_block block_6">
                                  <div className="title">
                                    曜日別リモート活用割合
                                  </div>
                                  <StackedBarChart
                                    labels={
                                      [
                                        {
                                          name: "リモート",
                                          color: REMOTE_COLOR,
                                        },
                                        {
                                          name: "オフィス",
                                          color: OFFICE_COLOR,
                                        },
                                      ]
                                    }
                                    list={
                                      list.summary.weekdays.map((value) => (
                                        {
                                          title: value.label,
                                          values: [
                                            {
                                              name: "リモート",
                                              value: (value.remote_work_time + value.office_work_time)
                                                ? value.remote_work_time / (value.remote_work_time + value.office_work_time)
                                                : 0,
                                              color: REMOTE_COLOR,
                                            },
                                            {
                                              name: "オフィス",
                                              value: (value.remote_work_time + value.office_work_time)
                                                ? value.office_work_time / (value.remote_work_time + value.office_work_time)
                                                : 0,
                                              color: OFFICE_COLOR,
                                            },
                                          ],
                                        }
                                      ))
                                    }
                                    chartSize={150}
                                    type="percent"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        <section className="page_contents content-area">
                          <div className="content-block">
                            <div className="block-header">
                              <div className="title">
                                ワークスタイルの比較
                              </div>
                              {
                                list.comparison.teams.length ? (
                                  <CsvModule
                                    title={
                                      `ワークスタイルの比較 ${format(date, "YYYY年MM月")}`
                                    }
                                    labels={{
                                      name: "チーム",
                                      remote_biz: "リモート操作量",
                                      office_biz: "オフィス操作量",
                                      remote_work_time: "リモート勤務時間",
                                      office_work_time: "オフィス勤務時間",
                                      remote_active_time: "リモート作業時間",
                                      office_active_time: "オフィス作業時間",
                                      remote_times: "リモート離席回数",
                                      office_times: "オフィス離席回数",
                                    }}
                                    list={
                                      list.comparison.teams.map((team) => (
                                        {
                                          name: team.name,
                                          remote_biz: team.remote_biz_point,
                                          office_biz: team.office_biz_point,
                                          remote_work_time: team.remote_work_time,
                                          office_work_time: team.office_work_time,
                                          remote_active_time: team.remote_active_time,
                                          office_active_time: team.office_active_time,
                                          remote_times: team.remote_inactive_count,
                                          office_times: team.office_inactive_count,
                                        }
                                      ))
                                    }
                                  />
                                ) : (
                                  <></>
                                )
                              }
                            </div>
                            <div className="block-detail">
                              <div className="grid_area">
                                <div className="grid_block block_4">
                                  <div className="title">
                                    1日当たりの平均操作量
                                  </div>
                                  <BarChart
                                    list={
                                      [
                                        {
                                          label: "リモート",
                                          value: list.comparison.remote.biz_point,
                                          color: REMOTE_COLOR,
                                        },
                                        {
                                          label: "オフィス",
                                          value: list.comparison.office.biz_point,
                                          color: OFFICE_COLOR,
                                        },
                                      ]
                                    }
                                    chartSize={200}
                                    type="biz"
                                  />
                                </div>
                                <div className="grid_block block_4">
                                  <div className="title">
                                    1日当たりの平均勤務時間
                                  </div>
                                  <StackedBarChart
                                    labels={
                                      [
                                        {
                                          name: "作業時間",
                                          color: [REMOTE_COLOR, OFFICE_COLOR],
                                        },
                                        {
                                          name: "離席時間",
                                          color: ["#999999"],
                                        },
                                      ]
                                    }
                                    list={
                                      [
                                        {
                                          title: "リモート",
                                          values: [
                                            {
                                              name: "離席時間",
                                              value: list.comparison.remote.work_time - list.comparison.remote.active_time,
                                              color: "#999999",
                                            },
                                            {
                                              name: "作業時間",
                                              value: list.comparison.remote.active_time,
                                              color: REMOTE_COLOR,
                                            },
                                          ],
                                        },
                                        {
                                          title: "オフィス",
                                          values: [
                                            {
                                              name: "離席時間",
                                              value: list.comparison.office.work_time - list.comparison.office.active_time,
                                              color: "#999999",
                                            },
                                            {
                                              name: "作業時間",
                                              value: list.comparison.office.active_time,
                                              color: OFFICE_COLOR,
                                            },
                                          ],
                                        },
                                      ]
                                    }
                                    chartSize={200}
                                    type="time"
                                  />
                                </div>
                                <div className="grid_block block_4">
                                  <div className="title">
                                    1日当たりの平均離席回数
                                  </div>
                                  <BarChart
                                    list={
                                      [
                                        {
                                          label: "リモート",
                                          value: list.comparison.remote.inactive_count,
                                          color: REMOTE_COLOR,
                                        },
                                        {
                                          label: "オフィス",
                                          value: list.comparison.office.inactive_count,
                                          color: OFFICE_COLOR,
                                        },
                                      ]
                                    }
                                    chartSize={200}
                                    type="times"
                                  />
                                </div>
                              </div>
                              {
                                list.comparison.teams.length ? (
                                  <div className="grid_area">
                                    <div className="grid_block no_border">
                                      <TableList
                                        labels={{
                                          name: "チーム",
                                          remote_biz: "リモート",
                                          office_biz: "オフィス",
                                          remote_work_time: "リモート",
                                          office_work_time: "オフィス",
                                          remote_active_time: "リモート",
                                          office_active_time: "オフィス",
                                          remote_times: "リモート",
                                          office_times: "オフィス",
                                        }}
                                        labelGroup={
                                          [
                                            {
                                              join_column_count: 1,
                                              parent_label: "",
                                            },
                                            {
                                              join_column_count: 2,
                                              parent_label: "平均操作量",
                                            },
                                            {
                                              join_column_count: 2,
                                              parent_label: "平均勤務時間",
                                            },
                                            {
                                              join_column_count: 2,
                                              parent_label: "平均作業時間",
                                            },
                                            {
                                              join_column_count: 2,
                                              parent_label: "平均離席回数",
                                            },
                                          ]
                                        }
                                        list={
                                          list.comparison.teams.map((team) => (
                                            {
                                              name: team.name,
                                              remote_biz: team.remote_biz_point,
                                              office_biz: team.office_biz_point,
                                              remote_work_time: team.remote_work_time,
                                              office_work_time: team.office_work_time,
                                              remote_active_time: team.remote_active_time,
                                              office_active_time: team.office_active_time,
                                              remote_times: team.remote_inactive_count,
                                              office_times: team.office_inactive_count,
                                            }
                                          ))
                                        }
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              }
                            </div>
                          </div>
                        </section>
                        <section className="page_contents content-area">
                          <div className="content-block">
                            <div className="block-header">
                              <div className="title">
                                作業内容の変化
                              </div>
                            </div>
                            <div className="block-detail">
                              <div className="grid_area">
                                <div className="grid_block">
                                  <StackedBarChart
                                    labels={
                                      [...list.variation.office.categories, ...list.variation.remote.categories].filter(
                                        (element, index, self) => self.findIndex((e) => e.id === element.id) === index,
                                      ).map((value) => (
                                        {
                                          name: CATEGORY.find((category) => category.id === value.id)?.title || "",
                                          color: CATEGORY.find((category) => category.id === value.id)?.color || "#EEEEEE",
                                        }
                                      ))
                                    }
                                    list={
                                      [
                                        {
                                          title: "リモート",
                                          values: list.variation.remote.categories.map((value) => (
                                            {
                                              name: CATEGORY.find((category) => category.id === value.id)?.title || "",
                                              value: value.work_time / list.variation.remote.categories.reduce(
                                                (count, val) => count + val.work_time, 0,
                                              ),
                                              color: CATEGORY.find((category) => category.id === value.id)?.color || "#EEEEEE",
                                            }
                                          )),
                                        },
                                        {
                                          title: "オフィス",
                                          values: list.variation.office.categories.map((value) => (
                                            {
                                              name: CATEGORY.find((category) => category.id === value.id)?.title || "",
                                              value: value.work_time / list.variation.office.categories.reduce(
                                                (count, val) => count + val.work_time, 0,
                                              ),
                                              color: CATEGORY.find((category) => category.id === value.id)?.color || "#EEEEEE",
                                            }
                                          )),
                                        },
                                      ]
                                    }
                                    chartSize={150}
                                    type="percent"
                                    horizontal
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </>
                    ) : (
                      <div className="no_data_area">
                        <div className="no_data_title">
                          データがありません
                        </div>
                        <div className="no_data_text">
                          期間条件や絞り込み条件をご確認ください。
                        </div>
                      </div>
                    )
                  }
                </>
              ) : (
                <>
                  <div className="no_data_area">
                    <div className="no_data_title">
                      オフィスのIPアドレスが設定されていません
                    </div>
                    <div className="no_data_text">
                      <p>
                        オフィスのIPアドレスが設定されていません。
                      </p>
                      <p>
                        <Link
                          to={setPath(URL.SETTING_OFFICE_IP_ADDRESS.path, language)}
                        >
                          こちら
                        </Link>
                        からオフィスのIPアドレスを設定してください。
                      </p>
                    </div>
                  </div>
                </>
              )
            }
          </>
        ) : (
          <div className="no_data_area">
            <div className="no_data_title">
              レポートを閲覧できない期間が指定されています。
            </div>
            <div className="no_data_text">
              期間条件をご確認ください。
            </div>
          </div>
        )
      }
    </>
  )
}

export default WorkStyle
